<template>
  <CContainer fluid>
    <h3>Documentos Soporte</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          :items="data_documents" 
          :fields="fields" 
          :items-per-page="itemsPerPage">
          <template #empresa="{item}">
            <td>
              <div>
                {{ item.empresa }}
              </div>
              <div>
                <h5>
                  {{ item.identificacion }}
                </h5>
              </div>
            </td>
          </template>
          <template #documento="{item}">
            <td>
              <div>
                <strong>
                  {{ item.documento }}
                </strong>
              </div>
              <div>
                <span>{{ item.prefijo }}</span>
                <span v-if="item.prefijo"> - </span>
                <span>{{ item.numero }}</span>
              </div>
              <div v-if="item.tipo_Movimiento == 'E'">
                  <i class="bi bi-cloud-check text-success h4 mr-1"></i>
                  <small>Transmitido</small>
                </div>
                <div v-else>
                  <i class="bi bi-cloud-slash text-danger h4 mr-1"></i>
                  <small>Sin Transmitir</small>
                </div>
                <div v-if="item.tipo_Impresion == 'CE'">
                  <i class="bi bi-envelope-check text-success h5 mr-1"></i>
                  <small>Enviado</small>
                </div>
                <div v-else>
                  <i class="bi bi-envelope-x text-danger h5 mr-1"></i>
                  <small>Sin Enviar</small>
                </div>
            </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                <span>
                  <i class="bi bi-calendar3 text-success mr-1"></i>
                  {{ moment(item.fecha_Emision).format("DD/MM/YYYY") }}
                </span>
              </div>
              <div>
                <span>
                  <i class="bi bi-calendar3 text-danger mr-1"></i>
                  {{ moment(item.fecha_Vencimiento).format("DD/MM/YYYY") }}
                </span>
              </div>
            </td>
          </template>
          <template #valores="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Mercancia, 0) }}</span>
              </div>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Iva, 0) }}</span>
              </div>
              <div class="d-flex justify-content-end">
                <strong>${{ formatter.format(item.valor_Total, 0) }}</strong>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td>
              <div class=" d-flex justify-content-center mt-1" v-if="item.tipo_Movimiento != 'E'">
                <a href="#" 
                  class="mr-2"
                  v-c-tooltip="'Enviar documento soporte'" 
                  @click="(event) => sendElectronicDocument(event, item.id_Documento)">
                  <Icon icon="mdi:receipt-text-send-outline" class="text-s3tail h3" />
                </a>
              </div>
            </td>
          </template>
        </CDataTable>
        <CPagination 
          size="sm" 
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)" />
      </CCardBody>

      <CElementCover v-show="loading" />

      <CElementCover :opacity="0.75" v-show="showProcess">
        <div class="text-dark bg-s3skyblue rounded border-dark p-3">
          <h4 class="d-inline mr-2">Procesando...</h4>
          <CSpinner size="sm" color="dark"/>
        </div>
      </CElementCover>
    </CCard>
  </CContainer>
</template>

<script>
  import moment from "moment"
  import { Icon } from "@iconify/vue2"
  import { formatter } from "@/general"
  import { dataGridDocumentos } from "@/apiDataGrids";
  import { sendElectronicDocument } from "@/apiProcess";
  const fields = [
    {
      key: "empresa",
      label: "Empresa",
      _style: "text-align:center"
    },
    {
      key: "documento",
      label: "Documento",
      _style: "text-align:center"
    },
    {
      key: 'fechas', 
      label: 'Fechas',
      _style:'text-align:center;'
    },
    {
      key: 'valores', 
      label: 'Valores',
      _style:'text-align:center;'
    },
    {
      key: "acciones",
      label: ""
    }
  ]

  export default {
    name: "SupportingDocuments",
    components: {
      Icon
    },
    data() {
      return {
        formatter,
        fields,
        loading: false,
        showProcess: false,
        data_documents: [],
        listEventStatus: [],
        updateComponent: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        eventStatusSelected: "",
        eventStatus: {
          "030": "Acuse de Recibo",
          "031": "Reclamo en documento",
          "032": "Recibo del bien o servicio",
          "033": "Aceptacion Expresa",
          "034": "Aceptacion Tacita"
        }
      }
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.page = page
        this.searchWord = search

        try {
          const { count, results } = await dataGridDocumentos(this, page, search)
          
          this.searchWord = search
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.data_documents = results
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async sendElectronicDocument(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();

        this.showProcess = true;

        try {
          const { errorCode, errorMessage } = await sendElectronicDocument(this, idDocument, null);

          if (errorCode === 0) {
            this.getData(this.page)

            this.$store.commit("setAlert", {
              color: "success",
              message: "El Documento fue enviado correctamente a la DIAN.",
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: `Error al enviar el documento a la DIAN. Error: ${errorCode} - ${errorMessage}`,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al enviar el documento a la DIAN.",
            show: 5
          });
        } finally {
          this.showProcess = false;
        }
      },
      loadEventStatus() {
        this.listEventStatus = [
          {
            "value": "",
            "label": "Todos"
          }
        ]

        Object.keys(this.eventStatus).map((key) => { 
          this.listEventStatus.push(
            {
              "value": key, 
              "label": this.eventStatus[key]
            }
          );
        });
      },
      getBadgeColor(estado) {
        if (estado === null || estado === "") return "info"
        if (estado === "030") return "dark"
        if (estado === "031") return "danger"
        if (estado === "032") return 'warning'
        if (estado === "033") return "success"
        if (estado === "034") return "success"
      }
    },
    mounted() {
      // this.loadEventStatus();
      this.getData(this.page);
    }
  }
</script>
